import { Text } from 'components';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const InvisContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: transparent;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 4;
  ${(props) => !props.visible && 'display: none'};

  @media (max-width: 1024px) {
    display: none;
  }
`;

const Wrapper = styled.div`
  position: fixed;
  width: ${(props) => (props.isMobile ? '100%' : `${props.wid || 408}px`)};
  height: ${(props) => (props.isMobile ? '100%' : `calc(100% + ${props.titleHt || 0}px)`)};
  right: ${(props) =>
    props.visible ? 0 : props.isMobile ? '-100vw' : `-${props.wid + 68 || 468}px`};
  top: 0;
  z-index: ${(props) => props.zIndex || '5'};

  background: ${(props) => props.bg || '#fff'};
  box-shadow: ${(props) => (props.visible ? '-8px 0px 32px rgba(0, 0, 0, 0.12)' : '0 0 0 0')};

  ${(props) =>
    props.fullScreen &&
    `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: calc(100vh - ${props.isMobile ? '57px' : '73px'});
    right: ${props.visible ? 0 : '-100vw'};
    top: ${props.isMobile ? '57px' : '73px'};
    ${props.isMobile && 'overflow: hidden;'};
    padding: 0;
  `}

  ${(props) =>
    props.ignoreHeader &&
    `
    top: 0;
    height: 100vh;
  `}

  transition: right 0.3s, box-shadow 0.3s;
`;

const Scrollable = styled.div`
  height: calc(100% - ${(props) => props.titleHt}px);
  overflow-y: scroll;
  scrollbar-width: none;
  padding: ${(props) => props.pad || (props.isMobile ? '0 16px 16px' : '0 24px 24px')};
`;

let scrolled = false;
const Sidepanel = (props) => {
  const {
    title,
    fullScreen,
    children,
    visible,
    closeModal = () => null,
    contentId,
    onContentEndReached,
    data,
    ignore = [],
    pad
  } = props;

  const [titleHeight, setTitleHeight] = useState(0),
    { isMobile } = useSelector((state) => state.appState),
    sidebarRef = useRef(),
    titleRef = useRef(),
    scrollRef = useRef();

  useEffect(() => {
    if (!contentId || !onContentEndReached) return;

    const scrollEl = document.getElementById(contentId);
    if (!scrollEl) return;

    scrollEl.addEventListener('scroll', onScroll);

    return () => scrollEl.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    scrollRef?.current?.scrollTo({ top: 0 });
  }, [visible]);

  useEffect(() => {
    setTitleHeight(titleRef?.current?.clientHeight);
  }, [titleRef]);

  async function onScroll(e) {
    if (scrolled) return;
    const scrollEl = document.getElementById(contentId);

    const bottomThreshold = e.target.scrollHeight - e.target.clientHeight,
      scrollHt = e.target.scrollTop + 200;

    if (scrollHt <= bottomThreshold && !scrolled) return;
    scrolled = true;

    await onContentEndReached();
    setTimeout(() => (scrolled = false), 200);
  }

  return (
    <React.Fragment>
      <InvisContainer visible={visible} onClick={closeModal} />

      <Wrapper {...props} isMobile={isMobile} ref={sidebarRef}>
        {fullScreen ? (
          <React.Fragment>{children}</React.Fragment>
        ) : (
          <React.Fragment>
            <div ref={titleRef}>
              <Text h2>{title}</Text>
            </div>

            <Scrollable
              titleHt={titleHeight}
              id={contentId}
              ref={scrollRef}
              isMobile={isMobile}
              pad={pad}
            >
              {children}
            </Scrollable>
          </React.Fragment>
        )}
      </Wrapper>
    </React.Fragment>
  );
};

export default Sidepanel;
